import { ChevronLeft } from "lucide-react";

import { BlogAnchor } from "./BlogAnchor";

// Checker amendment 5: white text on warmOrange-500 is about 2.8:1, warmOrange-700 passes 4.5:1.
export const BLOG_CTA_BUTTON_CLASS =
  "bg-warmOrange-700 hover:bg-warmOrange-800 text-white font-bold rounded-lg px-6 py-3 min-h-11 inline-flex items-center gap-2 no-underline mt-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warmOrange-500 focus-visible:ring-offset-2 motion-reduce:transition-none";

/** The /stores button alone, reused by the /blog empty state. Goes through BlogAnchor (tracked). */
export function BlogStoresButton() {
  return (
    <BlogAnchor href="/stores" className={BLOG_CTA_BUTTON_CLASS}>
      دوّر على المتجر قبل ما تدفع
      <ChevronLeft className="h-4 w-4" aria-hidden="true" />
    </BlogAnchor>
  );
}

/** End-of-post conversion block (UI-SPEC section 2 item 6, the post's conversion point). */
export function BlogEndCta() {
  return (
    <section className="mt-12 bg-white border border-gray-200 rounded-xl p-6 text-start font-arabic">
      <h2 className="text-xl font-bold text-gray-900">قبل ما تدفع لأي متجر</h2>
      <p className="text-base text-gray-600 mt-2">
        اكتب اسم المتجر أو لينك صفحته على يتفرج وشوف تقييمات المشترين الحقيقيين.
      </p>
      <BlogStoresButton />
    </section>
  );
}

export default BlogEndCta;
